import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";
@Injectable({
  providedIn: 'root'
})
export class TenderMatService extends BaseService{
  private url = "api/tenderMatNotice";

  constructor(http: HttpClient) {
    super(http);
  }
  getUrl(){
    return this.url;
  }
  //验证物料小类是否存在
  checkMatClass(params):Observable<any> {
    let url=this.url+`/check-matClass?matSubClass=`+params;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`checkMatClass`)),
      catchError(this.handleError<any>(`checkMatClass`))
    );
  }
}
